export const formatEtiquetaUbicacion = (input) => {
  // Validar entrada
  if (!input || typeof input !== "string" || input.length !== 6) {
    return input;
  }

  // Verificar que el primer carácter sea una letra
  if (!/^[A-Za-z]$/.test(input[0])) {
    return input; // No formatear si no empieza con letra
  }

  const [p1, p2, p3, p4, p5, p6] = input;
  return `${p1}-${p2}${p3}-${p4}${p5}-${p6}`;
};
